/* =============================================================================
   assets/rm-reveal.js
   IntersectionObserver-based reveal animations.
   Adds .visible to elements with .reveal / .reveal-* classes when they
   enter the viewport. CSS handles the actual transition.
   ============================================================================= */

(function () {
  'use strict';

  const SELECTORS = [
    '.reveal',
    '.reveal-fade',
    '.reveal-left',
    '.reveal-right',
    '.reveal-scale',
  ].join(', ');

  function init() {
    const elements = document.querySelectorAll(SELECTORS);
    if (!elements.length) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold:  0.08,
      rootMargin: '0px 0px -30px 0px',
    });

    elements.forEach(el => observer.observe(el));

    // Re-observe any newly added elements (e.g. after section renders)
    document.addEventListener('rm:section:loaded', () => {
      document.querySelectorAll(`${SELECTORS}:not(.visible)`).forEach(el => {
        observer.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
